<template>
  <footer class="footer">
    <p>Copyright&nbsp;&nbsp;上海予答信息技术有限公司&nbsp;&nbsp;<a class="beian" href="https://beian.miit.gov.cn/#/Integrated/index" target="__blank">沪ICP备16054093号-2</a></p>
  </footer>
</template>

<script>
export default {
  name: 'LayoutBottom'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .footer{
    height: 80px;
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background-color: #3D3D3D;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .beian{
      color: #fff;
      text-decoration: none;
      &:hover{
        color: #009eff;
      }
    }
  }
</style>
